import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import MainPagetitle from '../../layouts/MainPagetitle';
import UserListService from '../../api/services/UserListService';

const UsersList = () => {
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [UserList, setUserList] = useState([]);
    // const [currentPage, setCurrentPage] = useState(1);
    // const recordsPage = 50;
    // const lastIndex = currentPage * recordsPage;
    // const firstIndex = lastIndex - recordsPage;
    // const records = UserList.slice(firstIndex, lastIndex);
    // const npage = Math.ceil(UserList.length / recordsPage)
    // const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();

    // function prePage() {
    //     if (currentPage !== 1) {
    //         setCurrentPage(currentPage - 1)
    //     }
    // }

    // function changeCPage(id) {
    //     setCurrentPage(id);
    // }

    // function nextPage() {
    //     if (currentPage !== npage) {
    //         setCurrentPage(currentPage + 1)
    //     }
    // }

    const getUserList = async () => {
        try {
            let responseData = await UserListService.index().json()
            setUserList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }

    useEffect(() => {
        if (localStorage.getItem('admintoken')) {
            getUserList();
        }
        else {
            navigate('/');
        }
    }, [])

    const handleDelete = async (id) => {
        try {
            let responseData = await UserListService.destroy(id).json()
            if (responseData.status === true) {
                swal("User Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getUserList();
                    }
                })
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    
    const updateregisterstatus = async (e) => {
        e.preventDefault();
        let id = e.target.id
        try {
             
            let responseData = await UserListService.updateregisterstatus(id).json();
            if (responseData.status === true) {

                swal("Updated!!!").then((updatecheckstatus) => {
                    if (updatecheckstatus) {
                        getUserList();
                        window.location.reload();
                    }
                })
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }

    return (
        <>
            <MainPagetitle mainTitle="Login Accounts" pageTitle={'Login Accounts'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Login Accounts</h4>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th ><strong>No.</strong></th>
                                                    <th ><strong>Checked</strong></th>
                                                    <th><strong>Name</strong></th>
                                                    <th><strong>Email</strong></th>
                                                    <th><strong>Phone</strong></th>
                                                    <th><strong>Date of Birth</strong></th>
                                                    <th className="d-flex"><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {UserList.map((element, index) => {
                                                    return (
                                                        <tr style={{ textAlign: 'center' }}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                            {element.ischecked == 0 ? <span className="btn btn-success btn-sm ms-1">Checked</span> : 
                                                            <span className="btn btn-danger btn-sm ms-1">Not Checked</span>}
                                                            <Link id={element.id}  onClick={updateregisterstatus}> Change?</Link>
                                                            </td>
                                                            <td>{element.name}</td>
                                                            <td>{element.email}</td>
                                                            <td>{element.phone}</td>
                                                            <td>{element.dob}</td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <Link
                                                                        onClick={() =>
                                                                            swal({
                                                                                title: "Are you sure?",
                                                                                text: "Once deleted, you will not be able to recover this data!",
                                                                                icon: "warning",
                                                                                buttons: true,
                                                                                dangerMode: true,
                                                                            }).then((willDelete) => {
                                                                                if (willDelete) {
                                                                                    (handleDelete(element.id));
                                                                                }
                                                                            })
                                                                        }
                                                                        className="btn btn-danger shadow btn-xs sharp"
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </Link>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )})
                                                }
                                            </tbody>
                                        </table>
                                        {/* <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {UserList.length < lastIndex ? UserList.length : lastIndex}
                                                {" "}of {UserList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default UsersList;
